import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../../components/Sidebar";
import Content from "../../components/Content";
import DataConsole from "./Dataconsole";
import DocSettings from "./DocSettings";
import DataSet from "./Dataset";
import DataconsoleNavbar from "../../components/DataconsoleNavbar";
import { ToastProvider } from "react-toast-notifications";
import CustomToaster from "../../components/CustomToaster";
import { set } from "react-hook-form";

const index = ({ pageID, title,userType }) => { 
  const isMounted = useRef(true);
  const [toggleBtn, setToggleBtn] = useState(false);
  const toggle = () => setToggleBtn((val) => !val);
  const [visibleSidebar, setVisibleSidebar] = useState(true);
  const [OpenDocUpload, setOpenDocUpload] = useState(false);
  const [DatsetCount, setDatsetCount] = useState(0);
  const [toasterVisible, setToasterVisible] = useState(false);
  const [toasterMessage, setToasterMessage] = useState("");
  const [toasterAppearance, setToasterAppearance] = useState("success");
  const [NavbarCollapse, setNavbarCollapse] = useState(true);
  const [dataFromChild, setDataFromChild] = useState(null);
  const [navTitle, setnavTitle] = useState("Data Console");
  const [tabTitle, settabTitle] = useState("Documents");
  const [OpenDatasetDocList, setOpenDatasetDocList] = useState(true);
  const [OpenDatasetUserList, setOpenDatasetUserList] = useState(false);
  const [DatasetDocUpload, setDatasetDocUpload] = useState(false);
  const [DatasetUrlUpload, setDatasetUrlUpload] = useState(false);
  const [OpenUserUpload, setOpenUserUpload] = useState(false);
  const [OpenRetrievalParam, setOpenRetrievalParam] = useState(false);
  const [isAssistantDoc, setIsAssistantDoc] = useState(false);
  const [OpenQnaSettings,setOpenQnaSettings]=useState(false);
  const [OpenDocumentsettings, setOpenDocumentsettings] = useState(false);
  const [OpenDocsettingsList, setOpenDocsettingsList] = useState(false);
  const [fetchedValue, setFetchedValue] = useState(null); // Add state for fetched value
  const [selectedDataset, setSelectedDataset] = useState(null); // State to store selected dataset

  const handleDataFromChild = (data) => {
    setDataFromChild(data);
  };

  const handleFetchedValue = (value) => {
    setFetchedValue(value); // Set the fetched value
  };

  useEffect(() => {
    setnavTitle(title);
    setDataFromChild(null);
    openDocList();
  }, [title]);

  const handleDatasetSelect = (dataset) => {
    setSelectedDataset(dataset); // Store the selected dataset details
  };

  const handleOpenDocUpload = () => {
    setOpenDocUpload(!OpenDocUpload);
  };

  const handleDatasetDocUpload = () => {
    setDatasetDocUpload(!DatasetDocUpload);
  };

  const handleDatasetUrlUpload = () => {
    setDatasetUrlUpload(!DatasetUrlUpload);
  };

  const setCloseDocUpload = () => {
    setDatasetDocUpload(!DatasetDocUpload);
  };

  const showToaster = (message, appearance) => {
    setToasterVisible(true);
    setToasterMessage(message);
    setToasterAppearance(appearance);
  };

  const closeToaster = () => {
    setToasterVisible(false);
  };

  const handleCloseButtonClick = () => {
    setToggleBtn(false); // Set toggleBtn to false
  };

  const openDocList = () => {
    settabTitle("Documents List");
    setOpenDatasetDocList(true);
    setOpenDatasetUserList(false);
  };

  const openuserList = () => {
    settabTitle("Users List");
    setOpenDatasetUserList(true);
    setOpenDatasetDocList(false);
  };

  const openRetrievallist = () => {
    settabTitle("Retrieval Parameters");
    setOpenRetrievalParam(true);
    setOpenDatasetUserList(false);
    setOpenDatasetDocList(false);
    setIsAssistantDoc(false);
  };

  const handleOpenDocList = () => {
    settabTitle("DocSettings List");
    setOpenDocsettingsList(true);
    setOpenDatasetUserList(false);
    setOpenDatasetDocList(false);
    setOpenRetrievalParam(false);
    setIsAssistantDoc(false);
  };

  const OpenQnaSettingsHistorylist=()=>{
    settabTitle("QnaSettings History");
    setOpenQnaSettings(true);
    setOpenDatasetUserList(false);
    setOpenDatasetDocList(false);
    setOpenRetrievalParam(false);
    setOpenDocsettingsList(false);
    setIsAssistantDoc(false);
  }

  const OpenDocSettingsHistorylist=()=>{
    settabTitle("DocSettings History");
    setOpenDocumentsettings(true);
    setOpenDatasetUserList(false);
    setOpenDatasetDocList(false);
    setOpenRetrievalParam(false);
    setOpenDocsettingsList(false);
    setOpenQnaSettings(false);
    setIsAssistantDoc(false);
  }

  const handleOpenAssistantDoc = () => {
    settabTitle("Assistant Settings");
    setOpenDatasetUserList(false);
    setOpenDatasetDocList(false);
    setOpenRetrievalParam(false);
    setOpenDocsettingsList(false);
    setOpenQnaSettings(false);
    setOpenDocumentsettings(false);
    setIsAssistantDoc(true);
  };

  const handleDatasetUserUpload = () => {
    setOpenUserUpload(!OpenUserUpload);
  };

  const handleCloseUserUpload = () => {
    setOpenUserUpload(!OpenUserUpload);
  };

  const handleCloseUrlUpload = () => {
    setDatasetUrlUpload(!DatasetUrlUpload);
  };

  return (
    <div className="top-wrapper data-console-top-wrapper">
      <DataconsoleNavbar
        setToggle={toggle}
        handleOpenDocUpload={handleOpenDocUpload}
        handleDatasetDocUpload={handleDatasetDocUpload}
        handleDatasetUrlUpload={handleDatasetUrlUpload}
        handleDatasetUserUpload={handleDatasetUserUpload}
        showDatasetCount={DatsetCount}
        navTitle={navTitle}
        type={pageID}
        NavbarCollapse={NavbarCollapse}
        onDataFromChild={handleDataFromChild}
        openDocList={openDocList}
        openuserList={openuserList}
        openRetrievallist={openRetrievallist}
        OpenDatasetUserList={OpenDatasetUserList}
        OpenDatasetDocList={OpenDatasetDocList}
        OpenRetrievalParam={OpenRetrievalParam}
        OpenDocsettingsList={OpenDocsettingsList}
        OpenQnaSettingsHistorylist={OpenQnaSettingsHistorylist}
        OpenQnaSettings={OpenQnaSettings}
        OpenDocSettingsHistorylist={OpenDocSettingsHistorylist}
        handleOpenAssistantDoc={handleOpenAssistantDoc}
        OpenDocumentsettings={OpenDocumentsettings}
        handleOpenDocList={handleOpenDocList}
        isAssistantDataset={selectedDataset?.isAssistantDataset} // Pass the value
      />
      <Sidebar
        toggleBtn={toggleBtn}
        onCloseButtonClick={handleCloseButtonClick}
      />

      <Content toggleBtn={toggleBtn}>
        <div className="dataconsole-responsvive-body">
          {toasterVisible && (
            <CustomToaster
              message={toasterMessage}
              duration={3000}
              onClose={closeToaster}
              position="right-top"
              appearance={toasterAppearance}
            />
          )}
          {pageID === "data_console" ? (
            <DataSet
              OpenDocUpload={OpenDocUpload}
              setOpenDocUpload={setOpenDocUpload}
              setDatsetCount={setDatsetCount}
              showToaster={showToaster}
              dataFromChild={dataFromChild}
              handleOpenDocUpload={handleOpenDocUpload}
              isAssistantDataset={selectedDataset} // Pass isAssistantDataset as a prop
              datasetDetails={selectedDataset} // Pass the entire dataset details
              onDatasetSelect={handleDatasetSelect} // Pass callback
              setnavTitle="Data Console"
            />
          ) : pageID === "add_doc" ? (
            <DataConsole
              OpenDocUpload={OpenDocUpload}
              setCloseDocUpload={setCloseDocUpload}
              DatasetDocUpload={DatasetDocUpload}
              DatasetUrlUpload={DatasetUrlUpload}
              setDatsetCount={setDatsetCount}
              showToaster={showToaster}
              setnavTitle={setnavTitle}
              dataFromChild={dataFromChild}
              OpenDatasetDocList={OpenDatasetDocList}
              OpenDatasetUserList={OpenDatasetUserList}
              OpenRetrievalParam={OpenRetrievalParam}
              OpenDocsettingsList={OpenDocsettingsList} 
              OpenQnaSettings={OpenQnaSettings}
              OpenQnaSettingsHistorylist={OpenQnaSettingsHistorylist}
              OpenDocSettingsHistorylist={OpenDocSettingsHistorylist}
              handleOpenAssistantDoc={handleOpenAssistantDoc}
              OpenDocumentsettings={OpenDocumentsettings}
              tabTitle={tabTitle}
              OpenUserUpload={OpenUserUpload}
              handleCloseUserUpload={handleCloseUserUpload}
              handleCloseUrlUpload={handleCloseUrlUpload}
              openDocList={openDocList}
              openuserList={openuserList}
              openRetrievallist={openRetrievallist}
              handleOpenDocList={handleOpenDocList}
              fetchedValue={fetchedValue} // Pass fetched value as prop
              userType={userType}
              isAssistantDataset={selectedDataset?.isAssistantDataset} // Pass the value
              datasetDetails={selectedDataset} // Pass dataset details to Dataconsole
            />
          ) : (
            { pageID }
          )}
        </div>
      </Content>
    </div>
  );
};

export default index;
